import { HttpClient } from '@angular/common/http';
import { PrescDraftStore } from '../storage/presc-draft.store';
import { VoiceDraftStore } from '../storage/voice-draft.store';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AlertController, NavController } from '@ionic/angular';
import { BehaviorSubject, from, Observable, of, throwError } from 'rxjs';
import { tap, map, switchMap, take, catchError } from 'rxjs/operators';
import { SWASTHCONFIG } from '../../config';
import { SwstoragService } from "../storage/swstorag.service";
import { Storage } from '@ionic/storage';
import { ModulesApisService } from '../services/modules-apis.service';
// import { WebSocketService } from "./web-socket.service";
import { SWASTH_CONST } from '../constant';
import { WebsocketService } from "../services/websocket.service";

const helper = new JwtHelperService();
const TOKEN_KEY = 'swplus-token';
const REMEMBERME = 'rememberme';
const USERPROFILE = 'USERPROFILE';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  isRemember: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  token = '';
  remeStatus = "";
  S3BASE_URL = SWASTHCONFIG.S3BASE_URL;

  constructor(private readonly httpClient: HttpClient, private swstorage: SwstoragService,
    private alertCtrl: AlertController, private router: Router, private navCtrl: NavController, private storage: Storage, private modulesApis: ModulesApisService,
    private webSocket : WebsocketService) {
    this.loadToken();
  }

  async loadToken() {
    if (this.storage.get(TOKEN_KEY)) {
      console.log(': ', this.storage.get(TOKEN_KEY));
      const token = await this.storage.get(TOKEN_KEY);
      console.log('reme : ', this.storage.get(REMEMBERME));
      const rememberSt = await this.storage.get(REMEMBERME);
      if (token) {
        console.log('set token: ', token);
        this.token = token;
        let decodedToken = helper.decodeToken(this.token);
        console.log('decode token: ', decodedToken);
        this.modulesApis.decodedToken = helper.decodeToken(this.token);
        //alert(decodedToken.UID);

        this.webSocket.subcribe(decodedToken.UID, true,'doctor');
        
        // this.webSocket.subcribe('nurse2',false, decodedToken.type, decodedToken.TenantID);
        this.swstorage.getStorage("USERPROFILE").then((udata: any) => {
          console.log("logi user profile-->", udata);
          if(udata!=null)
          {
            if(udata.userType=="Doctor")
              {
              this.modulesApis.getDoctorProfile(udata.docprofile.docUserID).subscribe((docProfile:any)=>{
                // if(docProfile!=null && docProfile!=undefined)
                // {
                  SWASTH_CONST.APPOINTMENTMODE=docProfile.appointmentViewMode;
                  this.isAuthenticated.next(true);
                // }
                // else
                // {
                //   this.isAuthenticated.next(false);
                // }

              });
            }
            else if(udata.userType=="Nurse")
            {
            this.modulesApis.getNurseProfile(udata.nurseprofile.nurseUserID).subscribe((nurseProfile:any)=>{
              // if(nurseProfile!=null && nurseProfile!=undefined)
              // {
                SWASTH_CONST.APPOINTMENTMODE=nurseProfile.appointmentViewMode;
                this.isAuthenticated.next(true);
              // }
              // else
              // {
              //   this.isAuthenticated.next(false);
              // }
              
            });          
  
            }
            else if(udata.userType=="PharmacyUser")
            {
              this.modulesApis.getPharmacyProfile(udata.pharmacyprofile.pharUserID).subscribe((nurseProfile:any)=>{
                // SWASTH_CONST.APPOINTMENTMODE=nurseProfile.appointmentViewMode;
                this.isAuthenticated.next(true);
              });
            }
            else if(udata.userType=="Receptionist"){
              this.modulesApis.getRecepProfile(udata.recpprofile.recpUserID).subscribe((recepProfile:any)=>{
                // if(recepProfile!=null && recepProfile!=undefined)
                // {
                  SWASTH_CONST.APPOINTMENTMODE=recepProfile.appointmentViewMode;
                  this.isAuthenticated.next(true);
                // }
                // else
                // {
                //   this.isAuthenticated.next(false);
                // }
                
              });
            }
            else
            {
              this.isAuthenticated.next(false);
            }
          }
          else{
            this.isAuthenticated.next(false);
          }
        });        
      } else {
        this.isAuthenticated.next(false);
      }
      if (rememberSt) {
        console.log('remell set token: ', rememberSt);
        this.remeStatus = rememberSt;
        this.swstorage.getStorage("USERPROFILE").then((udata: any) => {
          console.log("logi user profile-->", udata);
          if(udata!=null)
          {
            if(udata.userType=="Doctor")
            {
              this.modulesApis.getDoctorProfile(udata.docprofile.docUserID).subscribe((docProfile:any)=>{
                // if(docProfile!=null && docProfile!=undefined)
                // {
                SWASTH_CONST.APPOINTMENTMODE=docProfile.appointmentViewMode;
                this.isRemember.next(true);
                // }
                // else
                // {
                //   this.isRemember.next(false);
                // }
              });
            }
            else if(udata.userType=="Nurse")
            {
  
              this.modulesApis.getNurseProfile(udata.nurseprofile.nurseUserID).subscribe((nurseProfile:any)=>{
                // if(nurseProfile!=null && nurseProfile!=undefined)
                // {
                SWASTH_CONST.APPOINTMENTMODE=nurseProfile.appointmentViewMode;
                this.isRemember.next(true);
                // }
                // else
                // {
                //   this.isRemember.next(false);
                // }
              });
  
            }
            else if(udata.userType=="PharmacyUser")
            {
              this.modulesApis.getPharmacyProfile(udata.pharmacyprofile.pharUserID).subscribe((nurseProfile:any)=>{
                // SWASTH_CONST.APPOINTMENTMODE=nurseProfile.appointmentViewMode;
                this.isRemember.next(true);
              });
            }
              else if(udata.userType=="Receptionist"){  
              this.modulesApis.getRecepProfile(udata.recpprofile.recpUserID).subscribe((recepProfile:any)=>{
                // if(recepProfile!=null && recepProfile!=undefined)
                // {
                SWASTH_CONST.APPOINTMENTMODE=recepProfile.appointmentViewMode;
                this.isRemember.next(true);
                // }
                // else
                // {
                //   this.isRemember.next(false);
                // }
              });
  
            }
            else
            {
              this.isRemember.next(false);
            }
          }
          else
          {
            this.isRemember.next(false);
          }
         
        });
        // this.isRemember.next(true);
      } else {
        this.isRemember.next(false);
      }
    }
    else {
      this.isRemember.next(false);
    }
  }

  loginDoctor(values, rememberMe): Observable<any> {
    console.log(values);
    return this.httpClient.post(`${SWASTHCONFIG.SERVER_URL}/followlogin`, values, { responseType: 'text' }).pipe(
      take(1),
      switchMap(token => {
        if (token !== 'NOTEXISTS') {
          this.token = token;
          // console.log('switch token: ', token);  
          if (rememberMe == 1) {
            from(this.storage.set(REMEMBERME, 'yes'));
          }
          let decodedToken = helper.decodeToken(this.token);
          //alert(decodedToken.UID);
          this.webSocket.subcribe(decodedToken.UID, true,'doctor');
          this.modulesApis.decodedToken = helper.decodeToken(this.token);
          return from(this.storage.set(TOKEN_KEY, token));
        } else if (token == 'NOTEXISTS') {
          this.showToast();
          return of(token);
        } else {
          alert("user not exists");
          return of(token);
        }
      }),
      tap(res => {
        if (res != 'NOTEXISTS') {
          this.isAuthenticated.next(true);
          this.isRemember.next(true);
        }
      })
    )
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err);
      })
    )
  }

  loginNurseRecept(values, rememberMe): Observable<any> {
    return this.httpClient.post(`${SWASTHCONFIG.SERVER_URL}/login`, values, { responseType: 'text' }).pipe(
      take(1),
      switchMap(token => {
        if (token !== 'NOTEXISTS') {
          this.token = token;
          // console.log('switch token: ', token);  
          if (rememberMe == 1) {
            from(this.storage.set(REMEMBERME, 'yes'));
          }
          let decodedToken = helper.decodeToken(this.token);
          console.log("nurrecep login-->", decodedToken);
          this.webSocket.subcribe(decodedToken.UID, true,'doctor');
          // this.webSocket.subcribe('nurse2',false, decodedToken.type, decodedToken.TenantID);
          console.log('type: ', decodedToken.type);
          this.modulesApis.decodedToken = helper.decodeToken(this.token);
          return from(this.storage.set(TOKEN_KEY, token));
        } else if (token == 'NOTEXISTS') {
          this.showToast();
          return of(token);
        } else {
          alert("user not exists");
          return of(token);
        }
      }),
      tap(res => {
        if (res != 'NOTEXISTS') {
          this.isAuthenticated.next(true);
          this.isRemember.next(true);
        }
      })
    )
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err);
      })
    )
  }

  getServerTime() {
    let url = SWASTHCONFIG.LOOKUP_URL + "/getServerDateTime/";
    return this.httpClient.get(url, { responseType: "text" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getAppointmentList(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getdocappointmentlist";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getAppointmentListnew(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getdocappointmentlistnew";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getVideoAppointmentListnew(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getdocvideoappointmentlistnew";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getVideoAppointmentListnew1(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getalldocvideoappointmentlistnew";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getAppointmentListnewbranch_old(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getdocappointmentlistnewbranch";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  // test api interface map getdocapptlistintrmapdata
  getAppointmentListnewbranchInterfaceMap(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getdocapptlistintrmapdata";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  // test api entity map getdocapptlistentitymapdata
  getAppointmentListnewbranch(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getdocappointmentlistnewbranch";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  // get single appointment with entities doctor, circle patient, circle family member, bill..
  getSingleApptDocBillCirclePtHosPtFamilyMem(apptID) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getdocsingleapptentitymapdata/"+apptID;
    return this.httpClient.get(epurl, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getVideoAppointmentListnewbranch(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getdocvideoappointmentlistnewbranch";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getAllVideoAppointmentListnewbranch(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getalldocvideoappointmentlistnewbranch";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getsinglevideoappointment(apptObj:any) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getsinglevideoappointmentnewbranch";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getVideoAppointmentWaiitngCount(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getwaitingappointmentbydoctor";
    return this.httpClient.post(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }


  getPatientAppointment(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getpatientappointments";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }


  createSwasthVideoChatRoom(videoObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/createswasthvideochatroom";
    return this.httpClient.post(epurl, videoObj, { responseType: "text" });
  }

  updateSwasthVideoAppt(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/updateswasthvideoappt";
    return this.httpClient.post(epurl, apptObj, { responseType: "text" });
  }

  // update video consultation of patient
  updateCircleFollowUpAppt(consultObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/updatecirclefollowupappt";
    return this.httpClient.put(epurl, consultObj, { responseType: "text" });
  }

  completeSwasthVideoAppt(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/completeswasthvideoappt";
    return this.httpClient.post(epurl, apptObj, { responseType: "text" });
  }

  private async showToast() {
    // console.log("Response Message======"+data);      
    const alert = await this.alertCtrl.create({
      header: 'Login Failed',
      message: 'Invalid User ID',
      buttons: ['ok']
    });
    await alert.present();
  }

  logout() {
    this.isAuthenticated.next(false);
    this.isRemember.next(false);
    PrescDraftStore.clearAll();
    VoiceDraftStore.clearAll();
    // this.webSocket.destroy.next(true);
    // Reset every in-memory value of the previous user, so the next login
    // never sees the old profile / hospital / branch.
    SWASTH_CONST.USER_PROFILE = {};
    SWASTH_CONST.HOSPITAL_PROFILE = {};
    SWASTH_CONST.ACCESS_SETTING = [];
    SWASTH_CONST.APPOINTMENTMODE = '';
    SWASTH_CONST.USER_TYPE = '';
    SWASTH_CONST.TENANTID = '';
    SWASTH_CONST.DOCTORUID = '';
    // Navigate only after storage is really cleared, so the old USERPROFILE
    // can't be read by the next user's first page load.
    const clearAll = Promise.all([
      this.swstorage.removeStorage(TOKEN_KEY),
      this.swstorage.removeStorage(REMEMBERME),
      this.swstorage.removeStorage(USERPROFILE),
      this.swstorage.removeStorage("DOCTORPROFILE"),
      this.swstorage.removeStorage("USERPROFILE"),
      this.swstorage.removeStorage("calendarObj"),
      this.swstorage.clearStorage(),
      this.storage.clear()
    ]).catch(err => console.log("storage clear error", err));
    // navigateRoot clears the page stack, so cached pages of the previous
    // user (patient list, appointment list...) are destroyed, not reused.
    return clearAll.then(() => this.navCtrl.navigateRoot('/login'));
  }

  login(values, rememberMe): Observable<any> {
    return this.httpClient.post(`${SWASTHCONFIG.SERVER_URL}/circlelogin`, values, {responseType: 'text'}).pipe(
      take(1),
      switchMap(token => {
        if(token !== 'NOTEXISTS'){     
          this.token = token;
          // console.log('switch token: ', token);  
          if(rememberMe == 1) {
            from(this.storage.set(REMEMBERME, 'yes'));
          }        
          let decodedToken = helper.decodeToken(this.token);
          this.webSocket.subcribe(decodedToken.UID,true,'patient');
          this.modulesApis.decodedToken = helper.decodeToken(this.token);
          return from(this.storage.set(TOKEN_KEY, token));
        } else if(token == 'NOTEXISTS') {
          this.showToast();
        }else {
          alert("user not exists");
        }        
      }),
      tap(_ => {
        this.isAuthenticated.next(true);
        this.isRemember.next(true);
      })
    );
  }

  otpLogin(values): Observable<any> {
    return this.httpClient.post(`${SWASTHCONFIG.SERVER_URL}/loginotp`, values, {responseType: 'text'}).pipe(
      take(1),
      switchMap(token => {
        if(token !== 'NOTEXISTS'){     
          this.token = token;
          // console.log('switch token: ', token);  
          // if(rememberMe == 1) {
          //   from(this.storage.set(REMEMBERME, 'yes'));
          // }        
          let decodedToken = helper.decodeToken(this.token);
          this.webSocket.subcribe(decodedToken.UID,true,'doctor');
          this.modulesApis.decodedToken = helper.decodeToken(this.token);
          return from(this.storage.set(TOKEN_KEY, token));
        } else if(token == 'NOTEXISTS') {
          this.showToast();
        }else {
          alert("user not exists");
        }        
      }),
      tap(_ => {
        this.isAuthenticated.next(true);
        this.isRemember.next(true);
      })
    );
  }

  // get Doctor RTC Token
  getDoctorRTCToken(doctoruid,channelName)
  {
    var epurl=SWASTHCONFIG.LOOKUP_URL+"/getrtctokendoctor/"+doctoruid+"/"+channelName;
    return this.httpClient.get(epurl,{responseType: 'text'});
  }

  // get Patient RTC Token
  getPatientRTCToken(patientuid,channelName)
  {
    var epurl=SWASTHCONFIG.LOOKUP_URL+"/getrtctokenpatient/"+patientuid+"/"+channelName;
    return this.httpClient.get(epurl,{responseType: 'text'});
  }

  // get Doctor RTM Token
  getDoctorRTMToken(doctoruid)
  {
    var epurl=SWASTHCONFIG.LOOKUP_URL+"/getrtmtokendoctor/"+doctoruid;
    return this.httpClient.get(epurl,{responseType: 'text'});
  }

  // get Patient RTM Token
  getPatientRTMToken(patientuid)
  {
    var epurl=SWASTHCONFIG.LOOKUP_URL+"/getrtmtokenpatient/"+patientuid;
    return this.httpClient.get(epurl,{responseType: 'text'});
  }

  // save agora video call details
  saveAgoraVideoCallDetails(agoraObj){
    var epurl=SWASTHCONFIG.LOOKUP_URL+"/saveagoradetails";
   // console.log("url......"+epurl);
    return this.httpClient.post(epurl, agoraObj, {responseType: "json"});
  }

  // Deactivate Member Doctor
  updateAgoraStatus(circlecode:any,doctoruid:any,patientuid:any,status:any) {
    var epurl=SWASTHCONFIG.LOOKUP_URL+"/updateagoracallstatus/"+circlecode+"/"+doctoruid+"/"+patientuid+"/"+status;
    return this.httpClient.put(epurl, {responseType: 'text'});
  }

   // send push notification to patient
   sendPatientPushNotification(notifobj) {
    let url = SWASTHCONFIG.LOOKUP_URL+"/circlepatientsend";
    return this.httpClient.post(url, notifobj, {responseType: "text"});
  }

  // send Web push notification to patient
  sendPatientWebPushNotification(notifobj) {
    let url = SWASTHCONFIG.LOOKUP_URL+"/webpushnotification";
    return this.httpClient.post(url, notifobj, {responseType: "text"});
  }
}

